var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9044 13.4427L9.99488 9.53324C10.9326 8.48641 11.4506 7.13013 11.4495 5.72474C11.4495 2.56812 8.88139 0 5.72474 0C2.56812 0 0 2.56812 0 5.72474C0 8.88139 2.56812 11.4495 5.72474 11.4495C7.13013 11.4506 8.48641 10.9326 9.53324 9.99488L13.4427 13.9044C13.5702 14.0319 13.7769 14.0319 13.9044 13.9044C14.0319 13.7769 14.0319 13.5702 13.9044 13.4427L13.9044 13.4427ZM0.65285 5.72475C0.65285 2.92809 2.92809 0.65285 5.72475 0.65285C8.52139 0.65285 10.7966 2.92809 10.7966 5.72474C10.7966 8.52139 8.52139 10.7966 5.72475 10.7966C2.92809 10.7966 0.65285 8.52139 0.65285 5.72475Z",
    transform: "translate(0.5 0.5)",
    id: "Shape-Copy-2",
    fill: "#000000",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/search-black.8a7bbbb32eb20fc84df5bd4ed31e2f77.svg";
export { ForwardRef as ReactComponent };